import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.svg";
import Toolstack from "./Toolstack";
import { CurrentFocus } from "./GithubHighlights";
import ExperienceTimeline from "./ExperienceTimeline";
import { useLanguage } from "../../context/LanguageContext";

function About() {
  const { t } = useLanguage();

  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              {t("about.title")} <strong className="purple">{t("about.me")}</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>

        <CurrentFocus />

        <ExperienceTimeline />

        <h1 className="project-heading">
          {t("about.skills")}
        </h1>

        <Techstack />

        <h1 className="project-heading">
          {t("about.tools")}
        </h1>
        
        <Toolstack />

      </Container>
    </Container>
  );
}

export default About;
